/**
 * This zod form hook is picked from https://www.brendonovich.dev/blog/the-ultimate-form-abstraction/
 */
/* eslint-disable import/prefer-default-export */
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormProps } from 'react-hook-form';
import { TypeOf, ZodSchema } from 'zod';

interface UseZodFormProps<Z extends ZodSchema> extends Exclude<UseFormProps<TypeOf<Z>>, 'resolver'> {
  schema: Z;
}

export const useZodForm = <Z extends ZodSchema>({ schema, ...formProps }: UseZodFormProps<Z>) =>
  useForm<TypeOf<Z>>({
    ...formProps,
    resolver: zodResolver(schema) as any,
  });

export { useForm };
